import { store } from 'redux/store';
import { setModal } from 'modules/_shared/redux/modalActions';

import UnpauseBeneficiaryModal from 'modules/beneficiaries/modals/UnpauseBeneficiary';
import { Beneficiary, User } from 'types';
import userTypes from 'constants/userTypes';

type PauseBeneficiaryParams = {
  data: Beneficiary;
  societyId: string;
  user: User;
  userType: keyof typeof userTypes;
  certificateData: any;
  isReadOnly: boolean;
};

const unPauseBeneficiary = (
  params: PauseBeneficiaryParams,
  beneficiaryId: string
) => {
  const { data } = params;

  store.dispatch(
    setModal(
      <UnpauseBeneficiaryModal
        beneficiaryId={beneficiaryId}
        beneficiary={data}
      />
    )
  );
};

export default unPauseBeneficiary;
